<template>
  <v-btn
    block
    depressed
    color="#F36F2E"
    class="btn"
    x-large
    v-on="$listeners"
    :disabled="disabled"
    :loading = "loading"
  >
  <slot/>
  </v-btn>
</template>

<script>
export default {
  props: {
    onClick: {
      type: Function,
      required: false,
    },
    disabled:{
      type:Boolean,
      // required: true
    },
    loading:{
      type: Boolean
    }
  }
}
</script>

<style lang="scss" scoped>
// import '@/assets/Global/scss/variables.scss'
@import '@/assets/Global/scss/variables.scss';

.btn{
  color:#ffffff !important;
  cursor:disable
}
.theme--light.v-btn.v-btn--disabled.v-btn--has-bg{
  opacity: 0.5;
  background-color: $Dtunes-orange !important;
  color:#ffffff !important;
}
</style>